import { Typography } from "@mui/material";
import type { ObjectFilter, SelectOption } from "../../api/types/objectTypes";
import ObjectBooleanFilterDescription from "./ObjectBooleanFilterDescription";
import ObjectDateFilterDescription from "./ObjectDateFilterDescription";
import ObjectGuidFilterDescription from "./ObjectGuidFilterDescription";
import ObjectMultiSelectFilterDescription from "./ObjectMultiSelectFilterDescription";
import ObjectNumberFilterDescription from "./ObjectNumberFilterDescription";
import ObjectTextFilterDescription from "./ObjectTextFilterDescription";

interface Props {
  fieldName: string;
  filter: ObjectFilter;
  selectOptions?: SelectOption[];
  startLabel: string;
}

const ObjectFilterDescriptionText = ({ fieldName, filter, selectOptions, startLabel }: Props) => {
  if (filter.textFilter) {
    return <ObjectTextFilterDescription fieldName={fieldName} filter={filter.textFilter} startLabel={startLabel} />;
  }

  if (filter.numberFilter) {
    return <ObjectNumberFilterDescription fieldName={fieldName} filter={filter.numberFilter} startLabel={startLabel} />;
  }

  if (filter.booleanFilter) {
    return (
      <ObjectBooleanFilterDescription fieldName={fieldName} filter={filter.booleanFilter} startLabel={startLabel} />
    );
  }

  if (filter.dateFilter) {
    return <ObjectDateFilterDescription fieldName={fieldName} filter={filter.dateFilter} startLabel={startLabel} />;
  }

  if (filter.multiSelectFilter) {
    return (
      <ObjectMultiSelectFilterDescription
        fieldName={fieldName}
        filter={filter.multiSelectFilter}
        options={selectOptions}
        startLabel={startLabel}
      />
    );
  }

  if (filter.guidFilter) {
    return (
      <ObjectGuidFilterDescription
        fieldName={fieldName}
        filter={filter.guidFilter}
        options={selectOptions}
        startLabel={startLabel}
      />
    );
  }

  return <Typography color="warning">Unsupported filter type</Typography>;
};

export default ObjectFilterDescriptionText;
